import { Close } from "@mui/icons-material";
import { Card, CardContent, IconButton, Stack } from "@mui/material";
import breakpoints from "../../../../assest/theme/base/breakpoints";
import PropTypes from "prop-types";
import MaterialBox from "../../../MaterialBox";
import MaterialTypography from "../../../MaterialTypography";
import Grid from "@mui/material/Grid2";

const SliderItem = ({ id, index, isHidden, video, image, title, description, actions, onlyItem, calculateMinWidth, onClose, moveToASpecificItem }) => {
    return (
        <div key={id} id={id}>
            {
                isHidden ? (
                    <div style={{
                        width: calculateMinWidth(),
                        minWidth: calculateMinWidth(),
                        height: '550px',
                        minHeight: '550px',
                        marginRight: '30px',
                        marginLeft: '30px',
                    }} />
                )
                    :
                    (
                        <Card key={index} style={{
                            width: calculateMinWidth(),
                            minWidth: calculateMinWidth(),
                            height: '550px',
                            minHeight: '550px',
                            marginRight: '30px',
                            marginLeft: '30px',
                            ...(index === 1 || onlyItem) ? {
                                transform: 'scale(1.04)',
                                transition: 'transform 1s 1s',
                            } : {
                                boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.1)',
                                transition: 'box-shadow 0.5s',
                                backgroundColor: 'white',
                            },
                            padding: 0,
                            marginTop: 0,
                        }}
                            sx={({
                                borders: { borderRadius },
                            }) => ({
                                borderRadius: borderRadius.lg,
                            })}
                            onClick={() => moveToASpecificItem(id)}
                        >
                            {
                                (index !== 1 && !onlyItem) && (
                                    <MaterialBox style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                        backdropFilter: 'blur(1px)',
                                        zIndex: 9,
                                        cursor: 'pointer',
                                        borderRadius: '8px'
                                    }} />
                                )
                            }

                            <CardContent style={{
                                display: 'flex', justifyContent: 'center', alignItems: 'center',
                                height: '100%', width: '100%',
                                marginTop: 0,
                                padding: 0,
                                overflow: 'auto',
                            }}
                                sx={({
                                    borders: { borderRadius },
                                }) => ({
                                    borderRadius: borderRadius.lg,
                                })}>
                                <MaterialBox style={{
                                    position: 'absolute',
                                    top: 0,
                                    right: 0,
                                    margin: '10px',
                                    zIndex: 8,
                                }}>
                                    <IconButton onClick={onClose} color="dark">
                                        <Close />
                                    </IconButton>
                                </MaterialBox>
                                <Grid container spacing={2} style={{
                                    height: '100%',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    paddingTop: 0,
                                    marginTop: 0,
                                }}
                                    direction="row"
                                >
                                    <Grid size={{xs:12}} style={{
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        height: '100%',
                                        padding: '20px 40px 20px 40px',
                                    }}>
                                        <Stack spacing={2} direction="column" justifyContent="space-between" alignItems="center" style={{
                                            height: '100%',

                                        }}>
                                            <Stack spacing={2} style={{
                                                marginTop: 50,
                                            }}>
                                                <MaterialTypography
                                                    variant="h5"
                                                    fontWeight="bold"
                                                    letterSpacing="-0.6px"
                                                    fontSize="24px"
                                                    fontFamily="Open Sans"
                                                >
                                                    {title}
                                                </MaterialTypography>
                                                <MaterialTypography
                                                    variant="body2"
                                                    fontSize="14px"
                                                    fontFamily="Open Sans"
                                                    fontWeight="medium"
                                                    style={{
                                                        whiteSpace: 'pre-line'
                                                    }}
                                                >
                                                    {description}
                                                </MaterialTypography>
                                            </Stack>
                                            {
                                                actions && (
                                                    <MaterialBox style={{ width: '100%', marginBottom: 20 }}>
                                                        {actions}
                                                    </MaterialBox>
                                                )
                                            }

                                        </Stack>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>

                    )
            }
        </div>
    )
}

SliderItem.propTypes = {
    id: PropTypes.string.isRequired,
    onlyItem: PropTypes.bool.isRequired,
    index: PropTypes.number.isRequired,
    isHidden: PropTypes.bool,
    video: PropTypes.string,
    image: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    actions: PropTypes.node,
    calculateMinWidth: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    moveToASpecificItem: PropTypes.func.isRequired,
}

SliderItem.defaultProps = {
    isHidden: false,
    onlyItem: false,
    video: null,
    image: null,
    title: '',
    description: '',
    actions: null,
    calculateMinWidth: () => { },
    onClose: () => { },
    moveToASpecificItem: () => { },
}

export default SliderItem;